<template>
	<v-card flat>
		<div class="basket-product-height">
			<div class="width-product-description">
				<div class="product-title-price-wrapper">
					<div class="product-title">{{ tagToLocalizedString(extractlabelFromTag) | translate(`priceRule.${getGlobalDiscountPriceRuleId}.displayLabel`) }}</div>
					<div class="product-price" v-if="!discountLoading">{{ formatPriceZero(receiptLine.totalPrice) }}</div>
				</div>
				<div class="order-discount">
					<p>{{ tagToLocalizedString(extractDiscountMessageFromTag)}}</p>
					<div v-for="tag in extractDiscountMessageFromTag" :key="tag">
						<br />
						<p>{{ tagToLocalizedString(tag) }}.</p>
					</div>
				</div>
			</div>
		</div>
	</v-card>
</template>

<script>
	import * as actions from "../../../../store/mutation-types";
	import {OrderLineType} from "../../../../domains2/orders/OrderLine2";
	import {formatPriceZero} from "../../../../domains2/libraries/Utils";
	import discountLocalizationMixin from "../../../../mixins/discountLocalization.mixin";
	import * as mutationTypes from "../../../../store/mutation-types";

	export default {
		name: "OrderDiscount-gt3",
		mixins: [ discountLocalizationMixin ],
		props: [
			"productSelection",
			"receiptLine",
			"orderLine",
			"discountLoading",
			"isProductConfiguring",
			"productCatalog"
		],
		data() {
			return {
				cartQuantityDialogShown: false,
				timeoutHandle: null
			};
		},
		async created() {
			if(this.$store.getters.isReorderState && !this.discountLoading) {
				await this.$store.commit(mutationTypes.SET_PREVIOUS_ORDER_TOTAL, this.$store.getters.totalPrice);
			}
		},
		computed: {
			productQuantity: {
				get() {
					const self = this;
					return parseInt(self.receiptLine.quantity);
				}
			},
			editableOnCheckout() {
				const self = this;
				return self.product.options.editableOnCheckout !== false;
			},
			productId() {
				return this.productSelection.productId;
			},
			productSelectionId() {
				return this.productSelection.productSelectionId;
			},
			isSimpleProduct() {
				const ol = this.orderLine;
				return ol.type !== OrderLineType.Aggregation;
			}
		},
		methods: {
			formatPriceZero,
			async changeQuantity(value) {

				const self = this;
				value = typeof value === "undefined" ? 0 : parseInt(value);

				if (value > 0) {
					await self.$store.dispatch(actions.UPDATE_CART_QUANTITY_BY_ID, {
						productSelectionId: self.productSelection.productSelectionId,
						quantity: value
					});
				} else {
					self.removeFromCart();
				}
				self.resetTimeout();
			},
			removeFromCart() {
				const self = this;
				this.$store.dispatch(actions.REMOVE_FROM_CART_BY_PRODUCT_SELECTION_ID, self.productSelectionId)
					.then(() => {
						self.cartQuantityDialogShown = false;
					});
			},
			resetTimeout() {
				const self = this;
				window.clearTimeout(self.timeoutHandle);
				self.timeoutHandle = window.setTimeout(() => {
					self.cartQuantityDialogShown = false;
				}, 3000);
			},
			openQuantityPopUp() {
				const self = this;
				self.cartQuantityDialogShown = true;
				self.resetTimeout();
			}
		}
	};
</script>

<style scoped lang="scss">
	.basket-product-height {
		min-height: 140px;
	}

	.order-discount p {
		color: #222222;
	}
	
	.basket-layout {
		display: inline-grid;

		.product-title {
			font-size: 22px;
			padding-bottom: 10px;
			line-height: 1;
		}

		.product-description {
			line-height: 1.4;
			padding-bottom: 20px;
			font-size: 17px;
		}
	}

	.amount-btn-edit {
		position: absolute;
		right: 10px;
		right: 10px;

		.add-btn-selected-color {
			background-color: #ffc627 !important;
			color: #231f20 !important;
			font-size: 30px;
			border: 1px solid #ffc627;
			height: 44px;
			width: 44px;
			min-width: 44px;
			border-radius: 4px;
			will-change: box-shadow;
			box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12) !important;
		}

		.edit-button-cr {
			background-color: white !important;
			height: 44px;
			width: 44px;
			min-width: 44px;
			border-radius: 4px;
		}

		.total-price, .discounted-total-price {
			font-size: 15px;
		}

		.discounted-total-price {
			.menu-price, .old-menu-price {
				display: inline;
			}
		}

		.edit-button-cr .v-icon {
			font-size: 32px;
		}

		.add-remove-btn {
			position: relative;
			text-align: center;
			background-color: #fff;
			-webkit-border-radius: 6px;
			-moz-border-radius: 6px;
			border-radius: 6px;
			box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
			padding: 4px;

			.v-btn {
				height: 44px;
				width: 44px;
				min-width: 44px;
				-webkit-border-radius: 4px;
				-moz-border-radius: 4px;
				border-radius: 4px;
				margin: 0;

				.v-btn__content {
					padding: 0 12px;
				}

				.v-icon {
					font-weight: bold;
				}
			}

			.v-chip {
				background-color: #ffffff;
				font-weight: bold;
				font-size: 30px;
				min-width: 60px;
				text-align: center;
				color: #231f20;
				margin: 4px 16px;

				/deep/ .v-chip__content {
					margin: 0 auto;
				}
			}

			.v-btn:last-child {
				background-color: #ffc627 !important;
				color: #231f20;
			}

			.v-btn:first-child {
				background-color: #d8d8d8 !important;
				color: #231f20;
			}
		}
	}

	@media(max-width: 420px) {
		.product-description {
			font-size: 15px !important;
		}
	}

	.theme--light .v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat) {
		background-color: #ffc627 !important;
		color: #231f20 !important;
		font-size: 30px;
		border: 1px solid #ffc627;
		height: 44px;
		width: 44px;
		min-width: 44px;
		border-radius: 4px;
		will-change: box-shadow;
		box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12) !important;
	}

	.bullet-basket-product {
		font-size: 8px;
		color: #23282A;
		padding-bottom: 4px;
		padding-right: 2px;
	}

	.lowercase-menu {
		text-transform: lowercase;
	}

	.remove-ease-button {
		margin-left: 0 !important;
		color: #63666a;
		text-decoration: underline;
		width: 35px !important;
		min-width: 35px !important;
		height: 25px !important;
		text-transform: capitalize;
		font-size: 16px;
	}
	.product-description{
		display: flex;
		font-family: Dispatch;
		font-size: 13px !important;
		font-weight: normal;
		font-stretch: normal;
		font-style: normal;
		line-height: 1.46;
		letter-spacing: normal;
		color: #222222;
		margin-top: 4px;
		margin-bottom: 29px;
		.unit-price{
			font-family: Dispatch;
			font-size: 14px;
			font-weight: bold;
			font-stretch: normal;
			font-style: normal;
			line-height: 1.36;
			letter-spacing: normal;
			color: #000000;
			padding-top: 16px;
		}
	}
</style>
